"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Snowrain = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Snowrain = function Snowrain(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.499 22.787a.999.999 0 01-.271-1.962A4.514 4.514 0 0026.5 16.5c0-2.482-2.019-4.5-4.5-4.5-.539 0-1.077.1-1.6.299l-.96.363-.338-.969A7.004 7.004 0 0012.5 7c-3.859 0-7 3.141-7 7a6.973 6.973 0 004.376 6.486 1 1 0 11-.752 1.854A8.965 8.965 0 013.5 14c0-4.963 4.037-9 9-9a9.006 9.006 0 018.127 5.149A6.422 6.422 0 0122 10c3.584 0 6.5 2.916 6.5 6.5a6.52 6.52 0 01-4.728 6.249.983.983 0 01-.273.038z",
    fill: "#D0D6E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 18.31a1 1 0 10-1.998-.002 1 1 0 001.998.002zm1.866 1.654A.996.996 0 0120 20.33l-.5-.29v.578a1 1 0 11-2 0v-.578l-.5.29a1.001 1.001 0 01-1-1.733l.5-.29-.5-.288a.999.999 0 01-.366-1.366.998.998 0 011.366-.366l.5.29v-.579a1 1 0 112 0v.579l.5-.29a.998.998 0 011.366.366A.999.999 0 0121 18.02l-.5.288.5.29a.999.999 0 01.366 1.366zM21.5 25v-1a1 1 0 10-2 0v1a1 1 0 102 0zm-8 0v-6a1 1 0 10-2 0v6a1 1 0 102 0zm3 3a1 1 0 01-1-1v-3a1 1 0 112 0v3a1 1 0 01-1 1z",
    fill: "#577EDC"
  }));
};

exports.Snowrain = Snowrain;
var _default = Snowrain;
exports.default = _default;